<template>
  <div class="bg bglight" id="notices-content">
    <div
      v-if="!isBackgroundLoading && backgroundStyle"
      :style="backgroundStyle"
      class="bghalf hidden-xs"
    ></div>
    <div
      v-if="isBackgroundLoading"
      class="bghalf hidden-xs"
      style="background-color: #f5f5f5; display: flex; align-items: center; justify-content: center;"
    >
      <p>Bild wird geladen...</p>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-md-offset-6 col-md-6 col-sm-12">
          <div class="bglight padding darkcolor right">
            <div class="testimonial">
              <div class="testimonial_slide">
                <div class="notices-body bottom0 top15" v-html="noticesHtml"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useBackgroundImageLoader } from "../../composables/index.js";
import { onMounted, watch, computed } from "vue";
import { normalizeInvertedStrongParagraphs } from "../../lib/normalizeCmsHtml.js";

export default {
  props: {
    content: Object, // Content object with content property
    backgound_image: Object,
  },
  setup(props) {
    const { backgroundStyle, isBackgroundLoading, loadBackgroundImage } = useBackgroundImageLoader();

    const noticesHtml = computed(() =>
      normalizeInvertedStrongParagraphs(props.content?.content || '')
    );

    const loadImage = async () => {
      if (props.backgound_image) {
        await loadBackgroundImage(props.backgound_image);
      }
    };

    onMounted(() => {
      loadImage();
    });

    // Watch für Änderungen am backgound_image prop
    watch(() => props.backgound_image, () => {
      loadImage();
    }, { deep: true });

    return {
      backgroundStyle,
      isBackgroundLoading,
      noticesHtml
    };
  }
};
</script>

<style scoped lang="scss">
.notices-body :deep(ul) {
  list-style: none;
  padding: 0;
  margin: 0 0 1em;
}

.notices-body :deep(li) {
  position: relative;
  padding-left: 1.5em;
  margin-bottom: 0.4em;
}

.notices-body :deep(li::before) {
  content: "\f00c";
  font-family: FontAwesome;
  color: #a3adb2;
  position: absolute;
  left: 0;
  top: 0.15em;
  width: 1em;
  line-height: 1;
}

.notices-body :deep(li p) {
  margin: 0;
}

.notices-body :deep(p) {
  margin: 0 0 0.75em;
}

.notices-body :deep(p:last-child) {
  margin-bottom: 0;
}

.notices-body :deep(strong) {
  display: block;
  margin: 0.75em 0 0.35em;
  font-weight: 700;
  font-synthesis: weight;
}

.notices-body :deep(strong:first-child) {
  margin-top: 0;
}
</style>
